import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';
import { authService } from '../services/auth';

const EduVerifyBanner: React.FC = () => {
  const { user, refreshUser } = useAuth();
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const [message, setMessage] = useState('');
  const [sending, setSending] = useState(false);

  if (!user || user.eduVerified || user.role === 'admin') {
    return null;
  }

  const handleSend = async () => {
    setSending(true);
    setMessage('');
    try {
      const result = await authService.sendEduCode();
      setMessage(result.message || t('edu.codeSent'));
    } catch (err: any) {
      setMessage(err.response?.data?.message || t('edu.sendFailed'));
    } finally {
      setSending(false);
    }
  };

  const handleVerify = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage('');
    try {
      await authService.verifyEduCode(code);
      await refreshUser();
      setMessage(t('edu.verifySuccess'));
    } catch (err: any) {
      setMessage(err.response?.data?.message || t('edu.verifyFailed'));
    }
  };

  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="max-w-7xl mx-auto px-4 py-3 sm:px-6 lg:px-8">
        <p className="text-sm text-amber-900">{t('edu.banner')}</p>
        <form onSubmit={handleVerify} className="mt-2 flex flex-wrap items-center gap-2">
          <button
            type="button"
            onClick={handleSend}
            disabled={sending}
            className="text-sm bg-amber-600 text-white px-3 py-1 rounded hover:bg-amber-700 disabled:opacity-50"
          >
            {sending ? t('edu.sending') : t('edu.sendCode')}
          </button>
          <input
            type="text"
            inputMode="numeric"
            maxLength={6}
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder={t('edu.codePlaceholder')}
            className="text-sm border border-amber-300 rounded px-2 py-1 w-28"
            aria-label={t('edu.codePlaceholder')}
          />
          <button
            type="submit"
            className="text-sm bg-white border border-amber-400 text-amber-900 px-3 py-1 rounded hover:bg-amber-100"
          >
            {t('edu.verify')}
          </button>
          <Link to="/safety" className="text-sm text-amber-800 underline">
            {t('footer.safety')}
          </Link>
        </form>
        {message && <p className="mt-1 text-xs text-amber-800">{message}</p>}
      </div>
    </div>
  );
};

export default EduVerifyBanner;
